export default __webpack_public_path__ + "static/media/pt_split_2.0462f3a2.svg";